export const dimensions = {
  footerHeight: "64px",
  headerHeightSmall: "71.2px",
  headerHeightLarge: "85px",
  maxWidth: "1444px",
};
